import { render, staticRenderFns } from "./Attechment.vue?vue&type=template&id=065655e8&"
import script from "./Attechment.vue?vue&type=script&lang=js&"
export * from "./Attechment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports